export default __webpack_public_path__ + "static/media/res-project-1.b256ab80.webp";